// Literal env checks so Vite constant-folds this and tree-shakes PostHog out of non-PostHog builds.
export const isPosthogAvailable =
  import.meta.env.VITE_ANALYTICS_TOOL === "posthog" &&
  !!import.meta.env.VITE_POSTHOG_KEY &&
  !!import.meta.env.VITE_POSTHOG_HOST;
